import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { notNil } from '../../core/helpers/is-nil';
import { NormalizedErrorMessage } from './openapi/api-types';
import { NormalizedError } from './errors';

type TranslatedNormalizedErrorsMap = Record<NormalizedErrorMessage, string>;

export const useTranslatedNormalizedErrors = () => {
  const { t } = useTranslation();

  const translatedNormalizedErrorMap = useMemo(
    () =>
      ({
        out_of_stock: t('global.normalizedErrors.outOfStock'),
        not_in_stock: t('global.normalizedErrors.notInStock'),
        custom: t('global.normalizedErrors.invalidValue'),
        invalid_value: t('global.normalizedErrors.invalidValue'),
        invalid_key: t('global.normalizedErrors.invalidValue'),
        invalid_element: t('global.normalizedErrors.invalidValue'),
        invalid_type: t('global.normalizedErrors.invalidValue'),
        invalid_format: t('global.normalizedErrors.invalidValue'),
        invalid_union: t('global.normalizedErrors.invalidValue'),
        not_multiple_of: t('global.normalizedErrors.invalidValue'),
        too_big: t('global.normalizedErrors.tooBig'),
        too_small: t('global.normalizedErrors.tooSmall'),
        unrecognized_keys: t('global.normalizedErrors.invalidValue'),
        required: t('global.formErrors.required'),
        generic_server_error: t('global.formErrors.genericServerError'),
      }) satisfies TranslatedNormalizedErrorsMap,
    [t],
  );

  const getSafeTranslatedError = (key: string) => {
    if (!(key in translatedNormalizedErrorMap)) {
      return key;
    }
    return translatedNormalizedErrorMap[key as NormalizedErrorMessage];
  };

  return {
    getSafeTranslatedError,
    getFirstOptionalErrorMessage: (error: unknown) => {
      return notNil(error) && error instanceof NormalizedError
        ? getSafeTranslatedError(error.messages[0].normalizedMessage)
        : undefined;
    },
  };
};
